import React from 'react';
import AdminLeads2Todo from './AdminLeads2Todo';
import AdminLayout from './AdminLayout';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import { Leads2PortalProvider } from '../../contexts/Leads2PortalContext';

const AdminLeads2TodoPage = () => {
  const { adminToken, adminUser } = useAdminAuth();
  const value = {
    token: adminToken,
    role: 'admin',
    basePath: '/admin/leads2',
    currentUserId: adminUser?.id || null,
    currentUserName: adminUser ? `${adminUser.firstName || ''} ${adminUser.lastName || ''}`.trim() : null,
    Layout: AdminLayout,
  };
  return (
    <Leads2PortalProvider value={value}>
      <AdminLeads2Todo />
    </Leads2PortalProvider>
  );
};

export default AdminLeads2TodoPage;
